export enum btnType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TEXT = "TEXT",
  OUTLINE = "OUTLINE",
}

export enum btnSize {
  DEFAULT = "DEFAULT",
  LARGE = "LARGE",
  SMALL = "SMALL",
}
